export default __webpack_public_path__ + "static/media/newspaper.3b4ba3ee.svg";